import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";

// Activé uniquement au démarrage de React en développement,
// avec REACT_APP_USE_FIREBASE_EMULATORS=true dans le terminal.
const useEmulators =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";

if (
  useEmulators &&
  !["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname)
) {
  throw new Error("Ouvre les tests Firebase sur http://localhost:3000.");
}

const firebaseConfig = useEmulators
  ? {
      apiKey: "demo-moviefrenzy-local-key",
      authDomain: "demo-moviefrenzy.firebaseapp.com",
      databaseURL: "https://demo-moviefrenzy-default-rtdb.firebaseio.com",
      projectId: "demo-moviefrenzy",
      storageBucket: "demo-moviefrenzy.appspot.com",
      messagingSenderId: "1234567890",
      appId: "1:1234567890:web:0123456789abcdef",
    }
  : {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const database = getDatabase(app);
const storage = getStorage(app);

// Brancher les émulateurs avant toute utilisation par les composants.
if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectDatabaseEmulator(database, "127.0.0.1", 9000);
  connectStorageEmulator(storage, "127.0.0.1", 9199);

  // forumActivityService.js connectera Functions sur le port 5001.
  console.info("[Firebase] MODE TEST LOCAL : demo-moviefrenzy");
} else {
  console.info("[Firebase] Mode habituel :", app.options.projectId);
}

export { auth, db, database, storage };
export default app;



// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
// import { getDatabase } from "firebase/database";

// // Configuration Firebase
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
// };

// // Initialiser Firebase
// const app = initializeApp(firebaseConfig);

// // Services conditionnels avec gestion d'erreur
// const auth = getAuth(app);
// const db = getFirestore(app);

// // Initialisation directe des services optionnels
// const database = getDatabase(app);
// console.log("✅ Firebase Realtime Database initialisé");

// const storage = getStorage(app);
// console.log("✅ Firebase Storage initialisé");

// // Export des services
// export { auth, db, database, storage };
// export default app;

